/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type {
  AccountGroupSort,
  AccountGroupStatusFilter,
  AccountGroupTab,
} from 'components/customers/groups/account/list-view/accountGroupRows'
import type { AccountGroupViewMode } from 'components/customers/groups/account/list-view/AccountGroupViewToggle'

export type GroupsPage = 'accountGroups'

export type GroupsPageView = {
  view: AccountGroupViewMode
  tab: AccountGroupTab
  search: string
  createdBy: string[]
  status: AccountGroupStatusFilter
  sort: AccountGroupSort
}

export type PersistentGroupsPageViewState = Record<GroupsPage, Partial<GroupsPageView>>

export const DEFAULT_GROUPS_PAGE_VIEW: GroupsPageView = { view: 'cards', tab: 'ALL', search: '', createdBy: [], status: 'ALL', sort: null }

const initialState: PersistentGroupsPageViewState = {
  accountGroups: DEFAULT_GROUPS_PAGE_VIEW,
}

const persistentGroupsPageViewSlice = createSlice({
  name: 'persistentGroupsPageView',
  initialState,
  reducers: {
    updateGroupsPageView(state, action: PayloadAction<{ page: GroupsPage; changes: Partial<GroupsPageView> }>) {
      const { page, changes } = action.payload
      state[page] = { ...state[page], ...changes }
    },
  },
})

export const { updateGroupsPageView } = persistentGroupsPageViewSlice.actions

// Spread over the defaults so a view persisted before a field existed still reads that field's default.
export const selectGroupsPageView = (
  state: { persistentGroupsPageView?: PersistentGroupsPageViewState },
  page: GroupsPage
): GroupsPageView => ({
  ...DEFAULT_GROUPS_PAGE_VIEW,
  ...state.persistentGroupsPageView?.[page],
})

export default persistentGroupsPageViewSlice.reducer
